import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import clsx from 'clsx';
import { BadgeType } from '@tribeplatform/gql-client/types';
import { useRouter } from '@tribeplatform/react-sdk';
import { useAssignBadge, useMember, useNetwork, useRevokeBadge, } from '@tribeplatform/react-sdk/hooks';
import { Button } from '@tribeplatform/react-ui-kit/Button';
import { Checkbox } from '@tribeplatform/react-ui-kit/Checkbox';
import { List } from '@tribeplatform/react-ui-kit/Layout';
import { Modal } from '@tribeplatform/react-ui-kit/Modal';
import { T, useI18n } from '../i18n';
import { MemberBadge } from './MemberBadge';
export const ManageBadgesModal = ({ memberId, onClose, open, }) => {
    var _a;
    const { Link } = useRouter();
    const { $t } = useI18n();
    const { data: { badges }, } = useNetwork();
    const { data: member } = useMember({
        variables: {
            id: memberId,
        },
        fields: 'default',
    });
    const { mutateAsync: assignBadge } = useAssignBadge();
    const { mutateAsync: revokeBadge } = useRevokeBadge();
    const assignableBadges = badges === null || badges === void 0 ? void 0 : badges.filter((b) => b.active && b.type === BadgeType.Manual);
    const initialBadgeIds = ((_a = member === null || member === void 0 ? void 0 : member.badges) === null || _a === void 0 ? void 0 : _a.map(b => b.badgeId)) || [];
    const [badgeIds, setBadgeIds] = useState(initialBadgeIds);
    const [isLoading, setIsLoading] = useState(false);
    useEffect(() => {
        var _a;
        setBadgeIds(((_a = member === null || member === void 0 ? void 0 : member.badges) === null || _a === void 0 ? void 0 : _a.map(b => b.badgeId)) || []);
    }, [member === null || member === void 0 ? void 0 : member.badges]);
    const onSubmit = async () => {
        const addedIds = badgeIds.filter(id => !initialBadgeIds.find(i => id === i));
        const revokedIds = initialBadgeIds.filter(id => !badgeIds.find(i => id === i));
        const promises = [];
        addedIds.forEach(id => promises.push(assignBadge({
            id,
            input: {
                memberId: member === null || member === void 0 ? void 0 : member.id,
            },
        })));
        revokedIds.forEach(id => promises.push(revokeBadge({
            id,
            input: {
                memberId: member === null || member === void 0 ? void 0 : member.id,
            },
        })));
        if (promises.length) {
            setIsLoading(true);
            await Promise.all(promises);
        }
        onClose();
    };
    return (_jsxs(Modal, { open: open, onClose: onClose, children: [_jsx(Modal.Header, { title: $t({
                    defaultMessage: 'Manage badges',
                    id: 'Generics.ManageBadges',
                }) }, void 0), _jsx(Modal.Content, { children: _jsxs(List, { spacing: "none", children: [assignableBadges === null || assignableBadges === void 0 ? void 0 : assignableBadges.map(badge => {
                            const isAssigned = badgeIds.find(badgeId => badgeId === badge.id);
                            const onClick = () => {
                                if (isAssigned) {
                                    setBadgeIds(badgeIds.filter(badgeId => badgeId !== badge.id));
                                }
                                else {
                                    setBadgeIds([...badgeIds, badge.id]);
                                }
                            };
                            return (_jsx(List.Item, { className: "group", children: _jsxs(Link, { onClick: onClick, href: "#", className: clsx('flex-1 border border-line-subdued rounded-md p-2 px-3 mb-2 bg-surface hover:bg-surface-hovered flex space-s-2 items-center'), children: [_jsx("div", { className: "pointer-events-none cursor-pointer", children: _jsx(Checkbox, { checked: !!isAssigned }, void 0) }, void 0), _jsx("span", { className: "flex-grow", children: badge.name }, void 0), _jsx(MemberBadge, { badge: badge }, void 0)] }, void 0) }, badge.id));
                        }), !(assignableBadges === null || assignableBadges === void 0 ? void 0 : assignableBadges.length) && (_jsxs(List.Item, { className: "pb-3", children: [_jsx("p", { children: _jsx(T, { defaultMessage: "No active badge is available to assign.", id: "Badges.NoActives" }, void 0) }, void 0), _jsx("p", { children: _jsx(T, { defaultMessage: "Please create or activate a badge in your community.", id: "Badges.NoActives.CTA" }, void 0) }, void 0)] }, void 0))] }, void 0) }, void 0), _jsxs(Modal.Footer, { className: "space-s-2 justify-end flex", children: [_jsx(Button, { variant: "outline", onClick: onClose, children: _jsx(T, { defaultMessage: "Cancel", id: "Generics.Cancel" }, void 0) }, void 0), _jsx(Button, { variant: "primary", onClick: onSubmit, loading: isLoading, children: _jsx(T, { defaultMessage: "Update badges", id: "Generics.UpdateBadges" }, void 0) }, void 0)] }, void 0)] }, void 0));
};
//# sourceMappingURL=ManageBadgesModal.js.map